// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__zSn0A","error":"Button_error__C4Zuq","success":"Button_success__QxIxS","primary":"Button_primary__4BysO"};